export const cibilTable = [
  "Sr No",
  "Lender",
  "Account number",
  "Actual payment",
  "Highest Credit",
  "Date opened",
  "Current Balance",
  "Amount Overdue",
  "Account Type",
  "EMI amount",
];
